<template>
	<wt-selector :options="options" v-model="Value" :disabled="disabled"></wt-selector>
</template>
<script>
import { detectionChineseType } from 'json/lab-order'
export default {
  name: 'detection-category-selector',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Value: this.value,
      options: this.change(detectionChineseType)
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    change (arr) {
      let options = []
      arr.forEach(element => {
        let obj = {
          label: element.key,
          value: element.value
        }
        options.push(obj)
      })
      return options
    }
  }
}
</script>
